import { Model } from '@models/base.model';

export class OrderState extends Model {
  name: string;
}
